import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  Form,
  Grid,
} from 'semantic-ui-react';
import BANKS_BY_COUNTRY from '../../constants/banks';
import { TRANSLATION_FILES } from '../../constants/translation';

import Validate from './Validate';

class SelectBank extends Component {
  static propTypes = {
    autoComplete: PropTypes.string,
    label: PropTypes.string,
    loading: PropTypes.bool,
    country: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    text: PropTypes.string,
    fullWidth: PropTypes.bool,
    validation: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
          validate: PropTypes.func,
          option: PropTypes.object,
        }),
      ]).isRequired,
    ),
    value: PropTypes.string,
    validateLabel: PropTypes.string,
    validateRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({}),
    ]),
    disabled: PropTypes.bool,
    style: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    t: PropTypes.func,
  }
  constructor(props) {
    super(props);
    let country = props.country || 'my';
    if (props.value) {
      const countryObj = this.findBankCountry(props.value);
      if (countryObj) {
        country = countryObj.country;
      }
    }
    this.state = {
      country,
    };
  }
  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    if (value !== this.props.value) {
      const countryObj = this.findBankCountry(value);
      if (countryObj) {
        const country = countryObj.country;
        this.setState({ country });
      }
    }
  }
  findBankCountry = val => BANKS_BY_COUNTRY.find(bbc => bbc.value.some(bank => bank.value === val))
  handleSelectCountry = (e, data) => {
    this.setState({ country: data.value });
    // reset bank value
    this.handleSelectBank(e, { value: '', name: this.props.name });
  }
  handleSelectBank = (e, data) => {
    if (this.props.onChange) {
      this.props.onChange(e, data);
    }
  }
  render() {
    const { country } = this.state;
    const { t } = this.props;
    const countries = [
      { text: 'ID', value: 'id' },
      { text: 'MY', value: 'my' },
      { text: 'SG', value: 'sg' },
      { text: 'VN', value: 'vn' },
    ];
    let bankOptions = [];
    const banksByCountry = BANKS_BY_COUNTRY.find(b => b.country === country);
    if (banksByCountry) {
      bankOptions = banksByCountry.value;
    }
    return (
      <div className="field">
        {
          this.props.label !== '' ?
            <label htmlFor={this.props.name}>{this.props.label}</label>
          : null
        }
        <Grid verticalAlign="middle" style={this.props.style && this.props.style}>
          <Grid.Column
            textAlign="left"
            width={this.props.fullWidth ? 16 : 4}
            style={this.props.fullWidth ? { paddingBottom: '0' } : { paddingRight: '0' }}
          >
            <Form.Select
              name="bankCountry"
              onChange={this.handleSelectCountry}
              options={countries}
              search
              selectOnBlur={false}
              value={country}
              style={{ minWidth: 'auto' }}
              disabled={this.props.disabled}
              noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
            />
          </Grid.Column>
          <Grid.Column textAlign="right" width={this.props.fullWidth ? 16 : 12}>
            <Validate
              hideMessage
              validation={this.props.validation}
              label={this.props.validateLabel || this.props.label}
              name={this.props.name}
              ref={this.props.validateRef}
              onChange={this.handleSelectBank}
            >
              <Form.Select
                fluid
                search
                autoComplete={this.props.autoComplete}
                loading={this.props.loading}
                name={this.props.name}
                options={bankOptions}
                placeholder={this.props.placeholder}
                text={this.props.text}
                selectOnBlur={false}
                value={this.props.value}
                disabled={this.props.disabled}
                noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
              />
            </Validate>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

const SelectBankWithTranslation = withTranslation([TRANSLATION_FILES.translation])(SelectBank);
export default forwardRef((props, ref) => <SelectBankWithTranslation {...props} validateRef={ref} />);



// WEBPACK FOOTER //
// ./src/components/AppForm/SelectBank.jsx